import clsx from 'clsx';
import {
  RelativeVertex,
  boundingBoxOfVertices,
  verticesToSvgPath
} from 'utils/space-polygon';

type ShapeSubmenuButtonProps = {
  vertices: RelativeVertex[];
  onClick: () => void;
  ariaLabel: string;
  size?: number;
};

const SHAPE_PADDING = 4;

export default function ShapeSubmenuButton({
  vertices,
  onClick,
  ariaLabel,
  size = 36
}: ShapeSubmenuButtonProps) {
  const bb = boundingBoxOfVertices(vertices);
  const viewBoxWidth = bb.width + SHAPE_PADDING * 2;
  const viewBoxHeight = bb.height + SHAPE_PADDING * 2;
  const viewBoxX = bb.minX - SHAPE_PADDING;
  const viewBoxY = bb.minY - SHAPE_PADDING;

  return (
    <button
      type='button'
      aria-label={ariaLabel}
      onClick={onClick}
      className={clsx(
        'flex items-center justify-center rounded border border-transparent',
        'bg-white text-gray-700 transition-colors',
        'hover:border-blue-400 hover:bg-blue-50',
        'focus:border-blue-500 focus:bg-blue-50 focus:outline-none'
      )}
      style={{ width: size, height: size }}
    >
      <svg
        aria-hidden='true'
        viewBox={`${viewBoxX} ${viewBoxY} ${viewBoxWidth} ${viewBoxHeight}`}
        className='h-full w-full'
        preserveAspectRatio='xMidYMid meet'
      >
        <path
          d={verticesToSvgPath(vertices)}
          fill='currentColor'
          fillOpacity={0.15}
          stroke='currentColor'
          strokeWidth={1.25}
          strokeLinejoin='miter'
          vectorEffect='non-scaling-stroke'
        />
      </svg>
    </button>
  );
}
